import store from "../storeDispatcher/store";

export default class InfoManager {

    static get languageList() {
        return [
            {'code': 'independent', 'name': 'Independent', 'nativeName': 'Independent'},
            {"code":"af","name":"Afrikaans","nativeName":"Afrikaans"},
            {"code":"sq","name":"Albanian","nativeName":"Shqip"},
            {"code":"ar","name":"Arabic","nativeName":"العربية"},
            {"code":"an","name":"Aragonese","nativeName":"Aragonés"},
            {"code":"hy","name":"Armenian","nativeName":"Հայերեն"},
            {"code":"as","name":"Assamese","nativeName":"অসমীয়া"},
            {"code":"az","name":"Azerbaijani","nativeName":"azərbaycan dili"},
            {"code":"be","name":"Belarusian","nativeName":"Беларуская"},
            {"code":"bn","name":"Bengali","nativeName":"বাংলা"},
            {"code":"bh","name":"Bihari","nativeName":"भोजपुरी"},
            {"code":"bs","name":"Bosnian","nativeName":"bosanski jezik"},
            {"code":"bg","name":"Bulgarian","nativeName":"български език"},
            {"code":"my","name":"Burmese","nativeName":"ဗမာစာ"},
            {"code":"ca","name":"Catalan; Valencian","nativeName":"Català"},
            {"code":"zh","name":"Chinese","nativeName":"中文"},
            {"code":"hr","name":"Croatian","nativeName":"hrvatski"},
            {"code":"cs","name":"Czech","nativeName":"česky"},
            {"code":"da","name":"Danish","nativeName":"dansk"},
            {"code":"nl","name":"Dutch","nativeName":"Nederlands"},
            {"code":"en","name":"English","nativeName":"English"},
            {"code":"et","name":"Estonian","nativeName":"eesti"},
            {"code":"fo","name":"Faroese","nativeName":"føroyskt"},
            {"code":"fj","name":"Fijian","nativeName":"vosa Vakaviti"},
            {"code":"fi","name":"Finnish","nativeName":"suomi"},
            {"code":"fr","name":"French","nativeName":"français"},
            {"code":"ka","name":"Georgian","nativeName":"ქართული"},
            {"code":"de","name":"German","nativeName":"Deutsch"},
            {"code":"el","name":"Greek","nativeName":"Ελληνικά"},
            {"code":"gn","name":"Guaraní","nativeName":"Avañeẽ"},
            {"code":"gu","name":"Gujarati","nativeName":"ગુજરાતી"},
            {"code":"ht","name":"Haitian","nativeName":"Kreyòl ayisyen"},
            {"code":"hi","name":"Hindi","nativeName":"हिन्दी, हिंदी"},
            {"code":"hu","name":"Hungarian","nativeName":"Magyar"},
            {"code":"id","name":"Indonesian","nativeName":"Bahasa Indonesia"},
            {"code":"ga","name":"Irish","nativeName":"Gaeilge"},
            {"code":"is","name":"Icelandic","nativeName":"Íslenska"},
            {"code":"it","name":"Italian","nativeName":"Italiano"},
            {"code":"ja","name":"Japanese","nativeName":"日本語"},
            {"code":"kl","name":"Greenlandic","nativeName":"kalaallisut"},
            {"code":"kn","name":"Kannada","nativeName":"ಕನ್ನಡ"},
            {"code":"km","name":"Khmer","nativeName":"ភាសាខ្មែរ"},
            {"code":"ki","name":"Gikuyu","nativeName":"Gĩkũyũ"},
            {"code":"rw","name":"Kinyarwanda","nativeName":"Ikinyarwanda"},
            {"code":"ky","name":"Kyrgyz","nativeName":"кыргыз тили"},
            {"code":"kg","name":"Kongo","nativeName":"KiKongo"},
            {"code":"ko","name":"Korean","nativeName":"한국어"},
            {"code":"lb","name":"Luxembourgish","nativeName":"Lëtzebuergesch"},
            {"code":"lt","name":"Lithuanian","nativeName":"lietuvių kalba"},
            {"code":"lv","name":"Latvian","nativeName":"latviešu valoda"},
            {"code":"mk","name":"Macedonian","nativeName":"македонски јазик"},
            {"code":"mg","name":"Malagasy","nativeName":"Malagasy fiteny"},
            {"code":"ms","name":"Malay","nativeName":" بهاس ملايو‎"},
            {"code":"ml","name":"Malayalam","nativeName":"മലയാളം"},
            {"code":"mt","name":"Maltese","nativeName":"Malti"},
            {"code":"mr","name":"Marathi","nativeName":"मराठी"},
            {"code":"mh","name":"Marshallese","nativeName":"Kajin M̧ajeļ"},
            {"code":"mn","name":"Mongolian","nativeName":"монгол"},
            {"code":"na","name":"Nauru","nativeName":"Ekakairũ Naoero"},
            {"code":"nb","name":"Norwegian Bokmål","nativeName":"Norsk bokmål"},
            {"code":"ne","name":"Nepali","nativeName":"नेपाली"},
            {"code":"ng","name":"Ndonga","nativeName":"Owambo"},
            {"code":"om","name":"Oromo","nativeName":"Afaan Oromoo"},
            {"code":"pa","name":"Panjabi","nativeName":"ਪੰਜਾਬੀ, پنجابی‎"},
            {"code":"pl","name":"Polish","nativeName":"polski"},
            {"code":"ps","name":"Pashto","nativeName":"پښتو"},
            {"code":"pt","name":"Portuguese","nativeName":"Português"},
            {"code":"ro","name":"Romanian","nativeName":"română"},
            {"code":"ru","name":"Russian","nativeName":"русский язык"},
            {"code":"sa","name":"Sanskrit","nativeName":"संस्कृतम्"},
            {"code":"sc","name":"Sardinian","nativeName":"sardu"},
            {"code":"sm","name":"Samoan","nativeName":"gagana faa Samoa"},
            {"code":"sr","name":"Serbian","nativeName":"српски језик"},
            {"code":"gd","name":"Scottish Gaelic","nativeName":"Gàidhlig"},
            {"code":"sn","name":"Shona","nativeName":"chiShona"},
            {"code":"si","name":"Sinhala","nativeName":"සිංහල"},
            {"code":"sk","name":"Slovak","nativeName":"slovenčina"},
            {"code":"sl","name":"Slovene","nativeName":"slovenščina"},
            {"code":"so","name":"Somali","nativeName":"Soomaaliga"},
            {"code":"st","name":"Southern Sotho","nativeName":"Sesotho"},
            {"code":"es","name":"Spanish","nativeName":"español"},
            {"code":"su","name":"Sundanese","nativeName":"Basa Sunda"},
            {"code":"sv","name":"Swedish","nativeName":"svenska"},
            {"code":"tg","name":"Tajik","nativeName":"тоҷикӣ"},
            {"code":"th","name":"Thai","nativeName":"ไทย"},
            {"code":"bo","name":"Tibetan Standard","nativeName":"བོད་ཡིག"},
            {"code":"tk","name":"Turkmen","nativeName":"Türkmen"},
            {"code":"tl","name":"Tagalog","nativeName":"Wikang Tagalog"},
            {"code":"tr","name":"Turkish","nativeName":"Türkçe"},
            {"code":"ug","name":"Uighur","nativeName":"Uyƣurqə"},
            {"code":"uk","name":"Ukrainian","nativeName":"українська"},
            {"code":"uz","name":"Uzbek","nativeName":"zbek"},
            {"code":"ve","name":"Venda","nativeName":"Tshivenḓa"},
            {"code":"vi","name":"Vietnamese","nativeName":"Tiếng Việt"},
            {"code":"za","name":"Zhuang, Chuang","nativeName":"Saɯ cueŋƅ"}
        ]
    }

    static languageName(code) {
        const language = this.languageList.find(it => it.code === code);
        return language ? (language.nativeName || language.name) : null;
    }

    static get systemLanguageList() {
        const langList = window.navigator.languages;
        return langList.map(it => it.includes('-') ? it.split('-')[0] : it);
    }

    static get currentLanguage() {
        const selectedLanguage = store.getState().selectedLanguage;
        if (selectedLanguage) return selectedLanguage;

        const systemLanguageList = this.systemLanguageList;
        if (systemLanguageList && systemLanguageList[0]) return systemLanguageList[0];

        return 'en';
    }

}